<template>
  <v-pagination
    v-model="page"
    :length="pages"
    variant="elevated"
    size="34"
    class="pa-2"
    active-color="black"
  ></v-pagination>
</template>

<script lang="ts">
  import { defineComponent } from "vue"
  export default defineComponent({
    props: {
      pageSize: {
        type: Number,
        default: 1,
        required: true,
      },
      pageNumber: {
        type: Number,
        default: 1,
      },
      list: {
        type: Array,
        required: true,
        default: () => [],
      },
      modelValue: {
        type: Array,
        required: true,
        default: () => [],
      },
    },
    emits: ["update:modelValue", "update:page"],
    data() {
      return {
        page: this.pageNumber,
      }
    },
    computed: {
      pages(): number {
        return Math.ceil(this.list.length / this.pageSize)
      },
    },
    watch: {
      page(newPage) {
        this.updatePage(newPage)
        this.$emit("update:page", newPage)
      },
      list() {
        // Stay on the current page as the list changes; only step back when
        // it no longer exists.
        const lastPage = Math.max(1, this.pages)
        if (this.page > lastPage) {
          this.page = lastPage
          return
        }
        this.updatePage(this.page)
      },
    },
    created() {
      this.updatePage(this.page)
    },
    methods: {
      updatePage(pageIndex: number) {
        const start = (pageIndex - 1) * this.pageSize
        const end = pageIndex * this.pageSize
        this.$emit("update:modelValue", this.list.slice(start, end))
      },
    },
  })
</script>
